import { getBaseUrl } from "@repo/utils";

/**
 * Browser: always same-origin `/api/rpc` (avoids CORS / host mismatches).
 *
 * Server (RSC prefetch): prefer the incoming request Host so we hit this
 * Next instance with the user's cookies. Using `SITE_URL` alone often points
 * at production while developing locally — the remote responds with an HTML
 * login/error page and the oRPC client surfaces "Cannot parse response body".
 */
export async function resolveOrpcRpcUrl(): Promise<string> {
	if (typeof window !== "undefined") {
		return new URL("/api/rpc", window.location.origin).toString();
	}

	try {
		const { headers } = await import("next/headers");
		const h = await headers();
		const host = h.get("x-forwarded-host")?.split(",")[0]?.trim() ||
			h.get("host")?.trim();
		if (host && host.length > 0) {
			const protoHeader = h.get("x-forwarded-proto")?.split(",")[0]?.trim();
			const proto =
				protoHeader === "http" || protoHeader === "https"
					? protoHeader
					: host.includes("localhost") || host.startsWith("127.")
						? "http"
						: "https";
			return `${proto}://${host}/api/rpc`;
		}
	} catch {
		// Outside a request scope (scripts / build) — fall through.
	}

	return `${getBaseUrl().replace(/\/$/, "")}/api/rpc`;
}
